import React from 'react'

import './HighlightsCarouselCard.css'

import ph__dot1 from '../../../assets/svg/ph__dot1.svg'
import ph__dot2 from '../../../assets/svg/ph__dot2.svg'
import ph__dot3 from '../../../assets/svg/ph__dot3.svg'
import primary_circle from '../../../assets/svg/primary_circle.svg'
import secondary_circle from '../../../assets/svg/secondary_circle.svg'
import avatar from '../../../assets/svg/avatar.svg'

const HighlightsCarouselCard = ({ company_name, company_website, image, placement_type, _package, student_batch, student_name, company_logo, type }) => {

    return (
            <div className="highlightsCarouselCard">
                <img src={ph__dot2} className="ph__dot2" alt='' />
                <img src={ph__dot3} className="ph__dot3" alt='' />
                <div className="highlight_left">
                    <img src={image ? image : avatar} alt="Highlights" className='highlight_left_img'/>
                    <img src={primary_circle} className='primary_circle' alt="" />
                    <img src={secondary_circle} className='secondary_circle' alt="" />
                </div>
                <div className="highlight_right">
                    <div className="line" />
                    <h1 className="title">CONGRATULATIONS</h1>
                    <h3 className="company">
                        ON YOUR {type} AT <a href={company_website} target='_blank' rel='noreferrer'>{company_name}</a>
                    </h3>
                    <h4 className="name">
                        {student_name}<span className='highlight_batch'>, Batch of {student_batch}</span>
                    </h4>
                    <a className="placed" href={company_website} target="_blank" rel="noreferrer">
                        <span>{type === 'INTERNSHIP' ? <>Intern</> : <>Placed</>} at</span>
                        <div className="logo">
                            <img src={company_logo} alt="" />
                        </div>
                    </a>
                </div>
                <img src={ph__dot1} className="ph__dot1" alt='' />
            </div>
    )
}

export default HighlightsCarouselCard